import { clr } from '../../screens/common/clr'
export const styles = {
  nav: {
    backgroundColor: clr.navbarBg
  }
}
